<template>
  <div>
    <check-sleep ref="checkSleepRef" />

    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="flex flex-shrink-0 bg-primary">
          <div class="flex items-center justify-between px-6 py-2 border-b md:flex-shrink-0 md:w-56">
            <Link href="/">
              <img src="/images/logo_header_golden.png" width="100">
            </Link>
          </div>
          <div class="md:text-md flex justify-end items-center p-4 w-full text-sm border-b md:px-12 md:py-0">
            <next-appointment />
            <notifications ref="notifications" />
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <svg class="w-6 h-6 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-white rounded shadow-lg">
                  <main-menu />
                </div>
              </template>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu ref="menuSide" :collapse="true" class="hidden flex-shrink-0 p-3 bg-white overflow-y-auto md:block" />
          <div class="flex flex-col w-full justify-between overflow-hidden">
            <div class="px-2 py-8 md:flex-1 md:p-6 md:overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200" scroll-region>
              <flash-messages />
              <slot />
              <modal-jitsi-meet ref="modalJitsiMeet" />
            </div>
            <div class="py-3 bg-gray-100 text-center text-gray-700">Copyright © {{ new Date().getFullYear() }}, ah.life</div>
          </div>
        </div>
      </div>
    </div>
    <modal-appointment v-if="appointmentStore.modal_appointment?.type_service !== 'external'" />
    <modal-logout ref="modalLogout" />
    <modal-support ref="modalSupport" />
    <modal-update-photo-profile ref="modalUpdatePhotoProfile" />
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import { Link } from '@inertiajs/inertia-vue3'
import Dropdown from '@/Shared/Components/Dropdown'
import MainMenu from '@/Shared/Layout/MainMenu'
import FlashMessages from '@/Shared/Layout/FlashMessages'
import Notifications from './Notifications'
import ModalJitsiMeet from '@/Shared/Modal/ModalJitsiMeet'
import NextAppointment from '@/Shared/Layout/NextAppointment'
import ModalAppointment from '@/Shared/Modal/ModalAppointment'
import ModalLogout from '@/Shared/Modal/ModalLogout'
import ModalSupport from '@/Shared/Modal/ModalSupport'

import ModalUpdatePhotoProfile from '../Modal/ModalUpdatePhotoProfile'
import { useAppointmentStore } from '@/Store/Appointment'

import CheckSleep from '@/Shared/Components/CheckSleep'


export default {
  provide() {
    return {
      collapseMenu: this.collapseMenu,
      openMenu: this.openMenu,
      openModalLogout: this.openModalLogout,
      openModalSupport: this.openModalSupport,
      openModalUpdatePhotoProfile: this.openModalUpdatePhotoProfile,
      stopInactivityMessage: this.stopInactivityMessage,
      startInactivityMessage: this.startInactivityMessage,

    }
  },
  components: {
    Dropdown,
    FlashMessages,
    Link,
    MainMenu,
    Notifications,
    ModalJitsiMeet,
    NextAppointment,
    ModalAppointment,
    ModalLogout,
    ModalSupport,
    ModalUpdatePhotoProfile,
    CheckSleep,
    ModalUpdatePhotoProfile,
  },
  props: {
    auth: Object,
  },
  data() {
    return {
      appointmentStore: useAppointmentStore()
    };
  },
  methods: {
    /**
     *
     * This function stops the timer to prevent the display
     * of the inactivity message.
     *
     */
    stopInactivityMessage() {
      const refToTimerComponent = this.$refs.checkSleepRef

      if (refToTimerComponent)
        refToTimerComponent.removeTimer()
    },

    /**
     * This function start the timer to display
     * the inactivity message.
     */
    startInactivityMessage() {
      const refToTimerComponent = this.$refs.checkSleepRef

      if (refToTimerComponent)
        refToTimerComponent.createTimer()
    },


    openMenu() {
      this.$refs.menuSide.openMenu();
    },
    collapseMenu() {
      this.$refs.menuSide.collapseMenu();
    },
    openModalLogout() {
      this.$refs.modalLogout.openModalLogout();
    },
    openModalSupport() {
      this.$refs.modalSupport.openModalSupport();
    },
    openModalUpdatePhotoProfile() {
      this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
    },
    verifyUserHasPhotoProfile() {

    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  mounted() {
    if(localStorage.showWalletNotify === 'true' && this.user.professional?.wallet?.confirmed === false) {
      localStorage.showWalletNotify = false;
    }

    if(this.user.professional){
      if(!this.user.photo) {
      this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();

    }

    }

  },
}
</script>
